import axiosInstance from "./axios";
import { Configuration } from "./models/configuration.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchConfiguration = async (
  bearerToken
): Promise<Configuration[]> => {
  try {
    const response = await axiosInstance.get(`${apiUrl}/Configuration`, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch configuration:", error);
    throw error;
  }
};
